export default {
  path: '/',
  name: 'supplier',
  component: () => import('@/layouts/BaseLayout'),
  children: [
    {
      path: 'supplier',
      meta: { title: '供应商', permission: 'supplier' },
      component: () => import('@/views/supplier/index'),
    },
  ],
}